import React from "react";
import Resolvers from "../../../../../componets/Api/Admin/Users";

class RenderAuthNav extends React.Component {
  state = {
    options: null,
    auth: null,
  };

  componentDidMount = async () => {
    var x_org = await Resolvers({ ...this.props, GetAllRoutes: true });
    var y = this.props.users.filter(f => f.id === this.props.idx)[0]?._routes;
    var actualAuth = [];
    var x = JSON.parse(this.props._decrypt(x_org.data));
    if (y?.length > 0) {
        y = y.split(",")
        y.map(y1 => {
            var itm = x.filter(f => f.value.toString() === y1);
            actualAuth.push(itm[0]);
        })
    }
    this.setState({ options: JSON.parse(this.props._decrypt(x_org.data)), auth: actualAuth });
  };

  updateUser = async (e) => {
    var auth = e.map((el) => el.value).join(",");
    this.setState({ auth: e });
    await Resolvers({
      ...this.props,
      SetAuthUser: true,
      data: {
        user: this.props.users.filter(f => f.id === this.props.idx)[0]?.email,
        auth: auth,
      },
    });
  };

  render() {
    const { Bs } = this.props;
    return (
      <>
        <Bs row>
          <Bs col>
            <Bs
              brtxselect
              onChange={(e) => this.updateUser(e)}
              isMulti
              options={this.state.options}
              value={this.state.auth}
              placeholder="Žádné vybrané oprávnění"
            />
            <Bs formtext>Oprávnění</Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}

export default RenderAuthNav;
